import React from 'react';

// Detect WebGL once so we can skip 3D entirely on unsupported devices.
export const hasWebGL = (() => {
    try {
        const canvas = document.createElement('canvas');
        return !!(window.WebGLRenderingContext && (canvas.getContext('webgl2') || canvas.getContext('webgl')));
    } catch (e) {
        return false;
    }
})();

// Keeps the page usable if a 3D scene fails to load or render.
class CanvasBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { failed: !hasWebGL };
    }

    static getDerivedStateFromError() {
        return { failed: true };
    }

    componentDidCatch(error) {
        if (process.env.NODE_ENV !== 'production') {
            console.warn('3D scene disabled:', error);
        }
    }

    render() {
        if (this.state.failed) return this.props.fallback || null;
        return this.props.children;
    }
}

export default CanvasBoundary;
